<template>
  <div class="mdc-layout-grid__cell" :class="classes">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'mdc-layout-cell',
  props: {
    span: {
      type: String,
      default: undefined
    },
    mobile: {
      type: String,
      default: undefined
    },
    phone: {
      type: String,
      default: undefined
    },
    tablet: {
      type: String,
      default: undefined
    },
    desktop: {
      type: String,
      default: undefined
    }
  },
  computed: {
    classes () {
      const spanClass = (this.span) ? 'mdc-layout-grid__cell--span-' + this.span : ''
      const mobileClass = (this.mobile) ? `mdc-layout-grid__cell--span-${this.mobile}-phone` : false
      const phoneClass = (this.phone) ? `mdc-layout-grid__cell--span-${this.phone}-phone` : false

      const tabletClass = (this.tablet) ? `mdc-layout-grid__cell--span-${this.tablet}-tablet` : ''
      const desktopClass = (this.desktop) ? `mdc-layout-grid__cell--span-${this.desktop}-desktop` : ''
      return {
        [spanClass]: this.span,
        [mobileClass]: this.mobile,
        [phoneClass]: this.phone,
        [tabletClass]: this.tablet,
        [desktopClass]: this.desktop
      }
    }
  }
}
</script>
